import { lazy } from 'react';

export default {
  home: lazy(() => import('./Home')),
};
